import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { CampaignsGrid } from '@/components/wizard/campaigns/campaigns-grid';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute(
  '/_authenticated/wizard/campaigns/$strategyId/',
)({
  loader: () => loadNamespaces('goals'),
  component: CampaignsGridRoute,
});

function CampaignsGridRoute(): ReactElement {
  const { strategyId } = Route.useParams();
  return <CampaignsGrid strategyId={strategyId} />;
}
